import React, {Component} from 'react';
import {Container, Menu, Image} from 'semantic-ui-react';
import {
    Route,
    HashRouter
} from "react-router-dom";


class Navbar extends Component {
    state = {
        activeItem: '/'
    };

    handleItemClick = (e, {name}) => this.setState({activeItem: name});

    addEntry = (label, name = '', size = 2) => (
        <Menu.Item
            name={name}
            active={this.state.activeItem === name}
            onClick={name === '' ? undefined : this.handleItemClick}
        >
            {label}
        </Menu.Item>
    );

    render = () => (
        <Menu stackable size='massive' style={{boxShadow: '1px 1px 4px #888888'}}>
            <Container>
                <Menu.Item>
                    <Image src={'/images/logo.png'} href='/'/>
                </Menu.Item>
                <Menu.Item href='/'>
                    Openito
                </Menu.Item>

                <Menu.Menu position='right'>
                    {[
                        {name: '+', key: '/addEvent'},
                        {name: 'Events', key: '/'},
                        {name: 'About', key: '/about'}
                    ].map(({name, key}) => (
                        <Route key={key} render={({history}) => (
                            <Menu.Item
                                onClick={(e, {name}) => {
                                    history.push(key);
                                    this.setState({activeItem: name});
                                }}
                                active={false}
                                name={key}
                                content={name}
                            />
                        )}/>
                    ))}
                </Menu.Menu>
            </Container>
        </Menu>

    );
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/Navbar.js